/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { PartnerResponse } from './platformapi.schemas';

import getActiveImpactPartnersMutator from '../custom-axios-instance';
import getAllPartnersMutator from '../custom-axios-instance';

/**
 * Retrieves a list of partners
 * @summary Get Active Impact Partners
 */
export const getActiveImpactPartners = (signal?: AbortSignal) => {
  return getActiveImpactPartnersMutator<PartnerResponse[]>({
    url: `${import.meta.env['VITE_API_HOST']}/partners/active`,
    method: 'GET',
    signal,
  });
};

export const getGetActiveImpactPartnersQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/partners/active`] as const;
};

export const getGetActiveImpactPartnersQueryOptions = <
  TData = Awaited<ReturnType<typeof getActiveImpactPartners>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getActiveImpactPartners>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetActiveImpactPartnersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getActiveImpactPartners>>> = ({
    signal,
  }) => getActiveImpactPartners(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getActiveImpactPartners>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetActiveImpactPartnersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActiveImpactPartners>>
>;
export type GetActiveImpactPartnersQueryError = void;

export function useGetActiveImpactPartners<
  TData = Awaited<ReturnType<typeof getActiveImpactPartners>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActiveImpactPartners>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveImpactPartners>>,
          TError,
          Awaited<ReturnType<typeof getActiveImpactPartners>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetActiveImpactPartners<
  TData = Awaited<ReturnType<typeof getActiveImpactPartners>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActiveImpactPartners>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveImpactPartners>>,
          TError,
          Awaited<ReturnType<typeof getActiveImpactPartners>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetActiveImpactPartners<
  TData = Awaited<ReturnType<typeof getActiveImpactPartners>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActiveImpactPartners>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Active Impact Partners
 */

export function useGetActiveImpactPartners<
  TData = Awaited<ReturnType<typeof getActiveImpactPartners>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getActiveImpactPartners>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetActiveImpactPartnersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieves a list of all partners
 * @summary Get All Partners
 */
export const getAllPartners = (signal?: AbortSignal) => {
  return getAllPartnersMutator<PartnerResponse[]>({
    url: `${import.meta.env['VITE_API_HOST']}/partners/all`,
    method: 'GET',
    signal,
  });
};

export const getGetAllPartnersQueryKey = () => {
  return [`${import.meta.env['VITE_API_HOST']}/partners/all`] as const;
};

export const getGetAllPartnersQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllPartners>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPartners>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllPartnersQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllPartners>>> = ({ signal }) =>
    getAllPartners(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllPartners>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAllPartnersQueryResult = NonNullable<Awaited<ReturnType<typeof getAllPartners>>>;
export type GetAllPartnersQueryError = void;

export function useGetAllPartners<
  TData = Awaited<ReturnType<typeof getAllPartners>>,
  TError = void,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPartners>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllPartners>>,
          TError,
          Awaited<ReturnType<typeof getAllPartners>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAllPartners<
  TData = Awaited<ReturnType<typeof getAllPartners>>,
  TError = void,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPartners>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllPartners>>,
          TError,
          Awaited<ReturnType<typeof getAllPartners>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAllPartners<
  TData = Awaited<ReturnType<typeof getAllPartners>>,
  TError = void,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPartners>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get All Partners
 */

export function useGetAllPartners<
  TData = Awaited<ReturnType<typeof getAllPartners>>,
  TError = void,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllPartners>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAllPartnersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
